import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dashboardFilter: {
    selectedTiles: [],
    locations: {},
  },
  timer: 0,
  groupData: [],
  dateRange: {
    startDate: null,
    endDate: null,
    type: "quick", // absolute
    peakHours: "",
    durationType: "",
  },
  refetch: undefined,
  prevTabId: null,
  prevDashboardHistory: [],
};

export const dashboardSliceV2 = createSlice({
  name: "dashboardV2",
  initialState,
  reducers: {
    setDashboardFilter: (state, action) => {
      state.dashboardFilter = { ...initialState.dashboardFilter, ...(action.payload || {}) };
    },
    setTimer: (state, action) => {
      state.timer = action.payload;
    },
    setGroupData: (state, action) => {
      state.groupData = action.payload;
    },
    setDateRange: (state, action) => {
      state.dateRange = { ...initialState.dateRange, ...(action.payload || {}) };
    },
    setRefetch: (state, action) => {
      state.refetch = action.payload;
    },
    setPrevTabId: (state, action) => {
      state.prevTabId = action.payload;
    },
    pushToHistory: (state, action) => {
      state.prevDashboardHistory = [...(state.prevDashboardHistory || []), action.payload];
    },
    popFromHistory: (state) => {
      if (state.prevDashboardHistory && state.prevDashboardHistory.length > 0) {
        state.prevDashboardHistory = state.prevDashboardHistory.slice(0, -1);
      }
    },
    clearHistory: (state) => {
      state.prevDashboardHistory = [];
    },
  },
});

export const {
  setDashboardFilter,
  setTimer,
  setGroupData,
  setDateRange,
  setRefetch,
  setPrevTabId,
  pushToHistory,
  popFromHistory,
  clearHistory,
} = dashboardSliceV2.actions;

export default dashboardSliceV2;
